<button *ngIf="(isClaimable() | async)"
        [ngbTooltip]="'item.page.claim.tooltip' | translate"
        class="edit-button btn btn-dark btn-sm"
        data-test="item-claim"
        (click)="claim()">
  {{'item.page.claim.button' | translate }}
</button>
